// ============================================
// ALMACEN/SECCIONHERRAMIENTAS.JS — herramientas como activos: "¿quién tiene el taladro?" (SUB-ALMACENES E, 2026-10-19)
// ============================================
// Vive en la pestana Central. Cada herramienta es un activo individual (numero de activo, serie si tiene). Prestar a un
// tecnico interno (queda a su resguardo, con fecha) y devolver a Central. Si lleva mas de 30 dias prestada, aviso a
// coordinacion (banner aqui y en Tecnicos; el tecnico la ve en rojo en su tarjeta).
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { fetchAuth } from '../../utils/sesion';
import { API_BASE } from '../../config/api';
import { fmtDinero } from '../../utils/dinero';
import { Modal, C, PP, card, inputBase, labelStyle, btn, btnCancelar, btnOk, btnPrimario, Aviso, Etiqueta, Foto, SelectTecnico, fmtDia } from './ui';
import ModalArticuloInterno from './ModalArticuloInterno';
import Kardex from './Kardex';

export function useTecnicos() {
  const [tecnicos, setTecnicos] = useState([]);
  useEffect(() => {
    let vivo = true;
    fetchAuth(`${API_BASE}/api/inventario/tecnicos?lista=1`).then(r => r.json()).then(d => { if (vivo && d.ok) setTecnicos(d.tecnicos || []); }).catch(() => {});
    return () => { vivo = false; };
  }, []);
  return tecnicos;
}

export default function SeccionHerramientas({ esCelular, veCostos, abiertaInicial = false }) {
  const [abierta, setAbierta] = useState(abiertaInicial);
  const [datos, setDatos] = useState(null);
  const [q, setQ] = useState('');
  const [error, setError] = useState('');
  const [aviso, setAviso] = useState('');
  const [modal, setModal] = useState(null); // {tipo:'alta'} | {tipo:'prestar', h} | {tipo:'kardex', h} | {tipo:'articulo'}
  const tecnicos = useTecnicos();
  const cargar = useCallback(async () => {
    try {
      const r = await fetchAuth(`${API_BASE}/api/inventario/herramientas?q=${encodeURIComponent(q.trim())}`);
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d.ok) throw new Error(d.error || 'No se pudieron leer las herramientas');
      setDatos(d); setError('');
    } catch (e) { if (e.code !== 'SESION_EXPIRADA') setError(e.message); }
  }, [q]);
  useEffect(() => { const h = setTimeout(cargar, 200); return () => clearTimeout(h); }, [cargar]);

  const accion = async (h, ruta, body, msg) => {
    setError(''); setAviso('');
    try {
      const r = await fetchAuth(`${API_BASE}/api/inventario/herramientas/${h.id}/${ruta}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body || {}) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d.ok) throw new Error(d.error || 'No se pudo');
      setAviso(msg); setModal(null); cargar();
    } catch (e) { if (e.code !== 'SESION_EXPIRADA') setError(e.message); }
  };

  const lista = (datos && datos.herramientas) || [];
  const vencidas = (datos && datos.vencidas) || 0, prestadas = (datos && datos.prestadas) || 0;
  const porTipo = useMemo(() => { const m = new Map(); for (const h of lista) { if (!m.has(h.nombre)) m.set(h.nombre, []); m.get(h.nombre).push(h); } return [...m.entries()]; }, [lista]);

  return (
    <div style={{ ...card, padding: esCelular ? 12 : 14 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
        <button onClick={() => setAbierta(a => !a)} style={{ border: 'none', background: 'transparent', cursor: 'pointer', fontFamily: PP, fontSize: 15, fontWeight: 800, color: C.oscuro, padding: 0, minHeight: 40, textAlign: 'left', flex: 1, minWidth: 200 }}>
          {abierta ? '▾' : '▸'} 🪛 Herramientas <span style={{ fontSize: 12, color: C.grisClaro, fontWeight: 600 }}>· {lista.length} activo{lista.length === 1 ? '' : 's'} · {prestadas} prestada{prestadas === 1 ? '' : 's'}{vencidas > 0 ? <strong style={{ color: C.rojo }}> · {vencidas} con más de {datos.dias_aviso} días</strong> : ''}</span>
        </button>
        <button onClick={() => setModal({ tipo: 'alta' })} style={btnPrimario()}>➕ Alta de herramienta</button>
      </div>
      {vencidas > 0 && <div style={{ marginTop: 8 }}><Aviso tipo="ambar" texto={`⚠️ Aviso a coordinación: ${vencidas} herramienta${vencidas === 1 ? '' : 's'} lleva${vencidas === 1 ? '' : 'n'} más de ${datos.dias_aviso} días prestada${vencidas === 1 ? '' : 's'}. ${lista.filter(h => h.vencida).map(h => `${h.nombre} (${h.numero_activo}) con ${h.prestada_a_nombre || '—'} desde ${fmtDia(h.prestada_en)}`).join(' · ')}`} /></div>}
      {abierta && (
        <div style={{ marginTop: 10, display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ fontSize: 12, color: C.grisClaro, lineHeight: 1.5 }}>Cada herramienta es un activo con su número. <strong>Prestar</strong> la deja a resguardo del técnico con fecha; <strong>Devolver</strong> la regresa a Central. Todo queda en el kardex.</div>
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="¿Quién tiene el taladro? Busca por herramienta, número, serie o técnico…" style={inputBase} />
          {aviso && <Aviso texto={aviso} />}
          {error && <Aviso tipo="error" texto={error} />}
          {!datos && !error && <div style={{ color: C.grisClaro, fontSize: 12 }}>Cargando…</div>}
          {datos && lista.length === 0 && <div style={{ color: C.grisClaro, fontSize: 12.5, padding: 10, textAlign: 'center' }}>Todavía no hay herramientas dadas de alta.</div>}
          {porTipo.map(([nombre, hs]) => (
            <div key={nombre} style={{ border: `1px solid ${C.borde}`, borderRadius: 10, padding: 10 }}>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <Foto src={hs[0].imagen_url} tam={36} />
                <div style={{ fontSize: 13.5, fontWeight: 800, color: C.gris, flex: 1 }}>{nombre}{hs[0].marca ? <span style={{ color: C.grisClaro, fontWeight: 600 }}> · {hs[0].marca}{hs[0].modelo ? ` ${hs[0].modelo}` : ''}</span> : null} <span style={{ fontSize: 11, color: C.grisClaro, fontWeight: 600 }}>· {hs.length}</span></div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 8 }}>
                {hs.map(h => (
                  <div key={h.id} style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', background: h.vencida ? '#fff5f5' : '#fafbfc', borderRadius: 8, padding: '6px 8px', fontSize: 12.5, color: C.gris }}>
                    <span style={{ fontFamily: 'monospace', fontWeight: 700, color: C.oscuro }}>{h.numero_activo}</span>
                    {h.serie ? <span style={{ color: C.grisClaro }}>S/N {h.serie}</span> : null}
                    <span style={{ flex: 1, minWidth: 140 }}>
                      {h.estado === 'prestada'
                        ? <><Etiqueta texto={h.vencida ? `⚠️ ${h.dias_prestada} días` : `${h.dias_prestada} día${h.dias_prestada === 1 ? '' : 's'}`} color={h.vencida ? C.rojo : C.ambar} /> con <strong>{h.prestada_a_nombre || h.tenedor_nombre}</strong> desde {fmtDia(h.prestada_en)}</>
                        : <Etiqueta texto="En Central" color={C.verde} />}
                      {veCostos && h.costo_compra != null ? <span style={{ color: C.grisClaro }}> · {fmtDinero(h.costo_compra)}</span> : null}
                    </span>
                    {h.estado === 'central' && <button onClick={() => setModal({ tipo: 'prestar', h })} style={btn(C.principal, C.principal, '#fff')}>Prestar</button>}
                    {h.estado === 'prestada' && <button onClick={() => accion(h, 'devolver', {}, `${h.nombre} (${h.numero_activo}) volvió a Central.`)} style={btn(C.verde, C.verde, '#fff')}>Devolver a Central</button>}
                    <button onClick={() => setModal({ tipo: 'kardex', h })} style={btn()}>Historial</button>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
      {modal && modal.tipo === 'alta' && <ModalAltaHerramienta veCostos={veCostos} onCerrar={() => setModal(null)} onHecho={(h) => { setModal(null); setAviso(`Herramienta ${h.nombre} dada de alta con el número ${h.numero_activo}.`); cargar(); }} />}
      {modal && modal.tipo === 'prestar' && (
        <ModalPrestar h={modal.h} tecnicos={tecnicos} onCerrar={() => setModal(null)} onPrestar={(usuarioId, nota) => accion(modal.h, 'prestar', { usuario_id: usuarioId, nota }, `${modal.h.nombre} (${modal.h.numero_activo}) queda a resguardo de ${(tecnicos.find(t => String(t.usuario_id) === String(usuarioId)) || {}).nombre || 'el técnico'}.`)} />
      )}
      {modal && modal.tipo === 'kardex' && (
        <Modal titulo={`Historial · ${modal.h.nombre} (${modal.h.numero_activo})`} onCerrar={() => setModal(null)}><div style={{ marginTop: 8 }}><Kardex filtro={{ herramienta_id: modal.h.id }} titulo="" /></div></Modal>
      )}
    </div>
  );
}

function ModalPrestar({ h, tecnicos, onCerrar, onPrestar }) {
  const [usuarioId, setUsuarioId] = useState('');
  const [nota, setNota] = useState('');
  return (
    <Modal titulo="Prestar herramienta" onCerrar={onCerrar} pie={<>
      <button onClick={onCerrar} style={btnCancelar}>Cancelar</button>
      <button disabled={!usuarioId} onClick={() => onPrestar(usuarioId, nota.trim() || null)} style={btnOk(!!usuarioId)}>Prestar</button>
    </>}>
      <div style={{ fontSize: 12.5, color: C.gris, marginTop: 6 }}><strong>{h.nombre}</strong> · {h.numero_activo}{h.serie ? ` · S/N ${h.serie}` : ''}</div>
      <label style={labelStyle}>¿A quién? (técnico interno)</label>
      <SelectTecnico tecnicos={tecnicos} value={usuarioId} onChange={setUsuarioId} style={{ width: '100%' }} />
      <label style={labelStyle}>Nota (opcional)</label>
      <input value={nota} onChange={(e) => setNota(e.target.value)} style={inputBase} placeholder="Para qué obra, hasta cuándo…" maxLength={500} />
      <div style={{ fontSize: 11, color: C.grisClaro, marginTop: 8 }}>Queda a su resguardo desde hoy. Si pasa de 30 días, aviso a coordinación.</div>
    </Modal>
  );
}

function ModalAltaHerramienta({ veCostos, onCerrar, onHecho }) {
  const [articulos, setArticulos] = useState([]);
  const [articuloId, setArticuloId] = useState('');
  const [nuevoTipo, setNuevoTipo] = useState(false);
  const [numero, setNumero] = useState('');
  const [serie, setSerie] = useState('');
  const [costo, setCosto] = useState('');
  const [fecha, setFecha] = useState('');
  const [nota, setNota] = useState('');
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);
  const cargarTipos = useCallback(() => { fetchAuth(`${API_BASE}/api/inventario/articulos-internos?tipo=herramienta`).then(r => r.json()).then(d => { if (d.ok) setArticulos(d.articulos || []); }).catch(() => {}); }, []);
  useEffect(() => { cargarTipos(); }, [cargarTipos]);
  const costoOk = costo.trim() === '' || /^\d+(\.\d+)?$/.test(costo.trim().replace(/,/g, ''));
  const listo = articuloId && costoOk && !enviando;
  const guardar = async () => {
    if (!listo) return;
    setEnviando(true); setError('');
    try {
      const r = await fetchAuth(`${API_BASE}/api/inventario/herramientas`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ articulo_id: Number(articuloId), numero_activo: numero.trim() || null, serie: serie.trim() || null, nota: nota.trim() || null, ...(veCostos && costo.trim() ? { costo_compra: costo.trim().replace(/,/g, '') } : {}), fecha_compra: fecha || null }) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d.ok) throw new Error(d.error || 'No se pudo dar de alta');
      onHecho(d.herramienta);
    } catch (e) { if (e.code !== 'SESION_EXPIRADA') setError(e.message); setEnviando(false); }
  };
  return (
    <>
      <Modal titulo="➕ Alta de herramienta (activo)" onCerrar={onCerrar} pie={<>
        <button onClick={onCerrar} style={btnCancelar}>Cancelar</button>
        <button onClick={guardar} disabled={!listo} style={btnOk(listo)}>{enviando ? 'Guardando…' : 'Dar de alta'}</button>
      </>}>
        <label style={labelStyle}>Tipo de herramienta</label>
        <div style={{ display: 'flex', gap: 6 }}>
          <select value={articuloId} onChange={(e) => setArticuloId(e.target.value)} style={inputBase}>
            <option value="">Elige…</option>
            {articulos.map(a => <option key={a.id} value={a.id}>{a.nombre}{a.marca ? ` · ${a.marca}` : ''}</option>)}
          </select>
          <button onClick={() => setNuevoTipo(true)} style={{ ...btn(C.principal), flexShrink: 0 }}>Nuevo tipo</button>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Número de activo</label>
            <input value={numero} onChange={(e) => setNumero(e.target.value)} style={inputBase} placeholder="Se asigna solo (HER-0001)" maxLength={40} />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Serie (si tiene)</label>
            <input value={serie} onChange={(e) => setSerie(e.target.value)} style={inputBase} maxLength={120} />
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          {veCostos && <div style={{ flex: 1 }}>
            <label style={labelStyle}>Costo de compra (MXN)</label>
            <input value={costo} onChange={(e) => setCosto(e.target.value)} style={inputBase} inputMode="decimal" placeholder="0.00" />
          </div>}
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Fecha de compra</label>
            <input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} style={inputBase} />
          </div>
        </div>
        <label style={labelStyle}>Nota (opcional)</label>
        <input value={nota} onChange={(e) => setNota(e.target.value)} style={inputBase} maxLength={1000} />
        {error && <div style={{ marginTop: 10, background: '#fde8e8', color: '#b02020', borderRadius: 10, padding: '8px 10px', fontSize: 12 }}>{error}</div>}
      </Modal>
      {nuevoTipo && <ModalArticuloInterno tipo="herramienta" onCerrar={() => setNuevoTipo(false)} onHecho={(a) => { setNuevoTipo(false); cargarTipos(); setArticuloId(String(a.id)); }} />}
    </>
  );
}
